
export default {
  name: 'BlueCheckbox',

  model: {
    prop: 'checked',
    event: 'change',
  },

  props: {
    text: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: '',
    },
    disabled: Boolean,
    alreadyChecked: Boolean,
  },

  data(): Record<string, unknown> {
    return {
      checked: false,
    };
  },

  watch: {
    alreadyChecked(): void {
      this.checked = this.alreadyChecked;
    },
  },
};
